{
  "Required": "Required",
  "ValidatingPassword": "Password must be atleast 6 characters long",
  "PasswordDoesNotMatch": "Password does not match",

  "ResetYourPassword": "Reset your password",
  "Password": "Password",
  "ConfirmPassword": "Confirm Password",
  "ResetButton": "Reset >",
  "Login": "Log In",
  "or": "or",
  "Signup": "Sign Up",
  "instead": "instead"
}
